import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
// import Table from "../../../core/common/dataTable/index";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CommonSelect from "../../../core/common/commonSelect";
import { DatePicker, Drawer, message, Modal, Select, TimePicker, } from "antd";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { BuildAttendance, getEmployeeAttendanceByDate } from "../../../core/data/redux/attendance/punch/punchAction";
import dayjs from "dayjs";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV } from "../../../core/common/GlobalFunctions/exportTableData";
import { formatTimeOnly } from "../../../core/utils/formatTime";
import { usePunchCSVImport } from "../../../customhooks/useAttendanceCSVImport";
import { Row, Col } from "antd";
import { fetchAllattendanceReport } from "../../../core/data/redux/reports/attendance_report/attendacnereport.Action";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import { fetchAllProjects } from "../../../core/data/redux/projects/project/projectAction";
import { createBulkPunchIn } from "../../../core/data/redux/attendance/punch/punchAction";
import { getEmployeeAttendancehierarchy } from "../../../core/data/redux/attendance/punch/punchAction";
import { Button } from "react-bootstrap";
import { decryptData } from "../../../core/utils/encryptUtils";
import { Pagination } from "antd";
import { Popover, Card } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";

function findNodeById(list: any[], id: number): any | null {
    for (const node of list || []) {
        if (node.EmployeeID === id) return node;
        const hit = findNodeById(node.Subordinates || [], id);
        if (hit) return hit;
    }
    return null;
}

interface AttendanceRecord {
    employee_id: number;
    name: string;
    department: string;
    project: string;
    punch_dates: string;
    leave_dates: string[];
    holidays?: string[];
}

interface Day {
    label: number;
    date: string;
    dayName: string;
}

interface CustomAttendanceTableProps {
    attendancelist: AttendanceRecord[];
    selectedMonth: string;
    selectedDept?: string;
    selectedProject?: string;
    selectedDay?: string | null;
    selectedEmployee?: any;
}


type Employee = {
    EmployeeID: number;
    EmployeeName: string;
    PictureURL?: string | null;
    Phone?: string | null;
    Department?: string | null;
    Designation?: string | null;
    PunchIn?: string | null;
    PunchOut?: string | null;
    Duration?: string | null;
    Subordinates: Employee[];
};

export const EmployeeNode: React.FC<{ employee: Employee; onClick?: (e: Employee) => void; showChevron?: boolean }> = ({ employee, onClick, showChevron = true }) => {
    return (
        <div
            onClick={() => onClick?.(employee)}
            style={{
                display: "grid",
                gridTemplateColumns: "auto 1fr auto",
                alignItems: "center",
                columnGap: 10,
                width: 300,
                padding: "12px 16px",
                background: "#ffffff",
                border: "1px solid #e5e7eb",
                borderRadius: 10,
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                cursor: onClick ? "pointer" : "default",
            }}
        >
            <img
                src={employee.PictureURL || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                alt="profile"
                onError={(e) => ((e.currentTarget as HTMLImageElement).style.display = "none")}
                style={{ width: 40, height: 40, objectFit: "cover", borderRadius: "50%", background: "#f3f4f6", border: "2px solid #e5e7eb", }}
            />

            <div style={{ minWidth: 0 }}>
                <strong
                    className="text-truncate"
                    style={{ display: "block", fontSize: 15, color: "#111827", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                    title={employee.EmployeeName}
                >
                    {employee.EmployeeName}
                </strong>
                <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}> {(employee.Designation || "No designation")} {employee.Department ? ` • ${employee.Department}` : ""} </div>
                <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>📞 {employee.Phone || "--"} </div>
            </div>

            <div style={{ display: showChevron && onClick ? "block" : "none" }}><RightOutlined style={{ fontSize: 14, color: "#6b7280" }} /></div>

            <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "space-between", gap: 12, marginTop: 8, fontSize: 12, color: "#374151" }}>
                <div><strong style={{ color: "#16a34a" }}>In:</strong>{employee.PunchIn ? new Date(employee.PunchIn).toLocaleTimeString() : "--"} </div>
                <div><strong style={{ color: "#dc2626" }}>Out:</strong>{employee.PunchOut ? new Date(employee.PunchOut).toLocaleTimeString() : "--"}</div>
                <div>⏱ <span style={{ fontWeight: 600 }}>{employee.Duration || "--"}</span></div>
            </div>
        </div>
    );
};


const AttendanceManager = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { employeeAttendanceAnalytics } = useSelector((state: any) => state.attendance.punch);
    const [selectedStatus, setSelectedStatus] = useState("All");
    const [selectedSort, setSelectedSort] = useState<any>("");
    const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DD"));
    const { handleCSVImport } = usePunchCSVImport();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [showSampleModal, setShowSampleModal] = useState<any>(false);
    const [selectedDept, setSelectedDept] = useState<string | undefined>();
    const [selectedProject, setSelectedProject] = useState<string | undefined>();
    const { departments } = useSelector((state: any) => state.department);
    const [selectedMonth, setSelectedMonth] = useState<string>(dayjs().format("YYYY-MM"));
    const [employeeAttendancehir, setemployeeAttendancehir] = useState<any[]>([])
    const orgViewportRef = useRef<HTMLDivElement | null>(null);
    const { user } = useSelector((state: any) => state.auth);
    const { employeesbyUser } = useSelector((state: any) => state.employee);
    const employeeId = employeesbyUser?.employeeId;
    const [selectedEmployee, setSelectedEmployee] = useState<any>();

    // Permission
    const encryptedPermissions = localStorage.getItem('currentPermissions');
    const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

    const canView =
        permissions.includes("View") || permissions.includes("AllowAll");
    const canEdit =
        permissions.includes("Edit") || permissions.includes("AllowAll");
    const canDelete =
        permissions.includes("Delete") || permissions.includes("AllowAll");
    const canImport =
        permissions.includes("Import") || permissions.includes("AllowAll");

    const triggerImportFileSelect = () => {
        fileInputRef.current?.click();
    };

    const filteredHierarchy = useMemo(() => {
        if (!Array.isArray(employeeAttendancehir) || employeeAttendancehir.length === 0) return [];
        if (!employeeId) return employeeAttendancehir; // fallback if you don't know the current user yet

        const me = findNodeById(employeeAttendancehir, employeeId);
        // If found, render ONLY my subtree; otherwise render everything
        return me ? [me] : employeeAttendancehir;
    }, [employeeAttendancehir, employeeId]);


    const handleBuildAttendance = () => {
        if (selectedMonth) {
            const month = dayjs(selectedMonth).format("MM");
            const year = dayjs(selectedMonth).format("YYYY");
            dispatch(BuildAttendance({ month, year }))
                .then((res) => {
                    message.success(res.payload.message)
                })
        } else {
            console.log("No month selected!");
        }
    };

    const CustomAttendanceTable: React.FC<CustomAttendanceTableProps> = ({
        attendancelist,
        selectedMonth,
        selectedDept,
        selectedProject,
        selectedDay,
        selectedEmployee,
    }) => {
        const [daysInMonth, setDaysInMonth] = useState<Day[]>([]);
        const [originalCheckedState, setOriginalCheckedState] = useState<{ [key: string]: boolean; }>({});
        const [checkedState, setCheckedState] = useState<{ [key: string]: boolean; }>({});
        const [attendanceState, setAttendanceState] = useState<{ [key: string]: string }>({});
        const [timeState, setTimeState] = useState<{
            [key: string]: { [status: string]: { inTime?: string; outTime?: string } };
        }>({});
        const [open, setOpen] = useState(false);

        const [currentPage, setCurrentPage] = useState(1);
        const pageSize = 20;

        const dispatch = useDispatch<any>();

        const ATTENDANCE_OPTIONS = [
            { value: "Present", label: "Present", color: "#4CAF50" },
            { value: "Half_Day", label: "Half_Day", color: "#2196F3" },
            { value: "holiday", label: "Holiday", color: "#2196F3" },
            { value: "Absent", label: "Absent", color: "#F44336" },
            { value: "Leave", label: "Leave", color: "#FF9800" },
            { value: "Weekoff", label: "Weekoff", color: "#9C27B0" },
        ];

        const AttendanceCell = React.memo(
            ({
                empId,
                date,
                value,
                onChange,
            }: {
                empId: number;
                date: string;
                value?: string;
                onChange: (val: string) => void;
            }) => {
                const cellKey = `${empId}-${date}`;
                const [open, setOpen] = useState(false);

                const handleStatusClick = (optValue: string) => {
                    onChange(optValue);

                    if (["Absent", "Leave", "Weekoff"].includes(optValue)) {
                        setOpen(false);
                    }
                };

                const content = (
                    <Card size="small" style={{ width: 280, borderRadius: 8 }} bodyStyle={{ padding: 12 }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            {ATTENDANCE_OPTIONS.map((opt) => {
                                const timeForOpt = timeState[cellKey]?.[opt.value] || {};
                                const showTimeInputs = opt.value === "Present" || opt.value === "Half_Day";

                                return (
                                    <div
                                        key={opt.value}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            cursor: "pointer",
                                            background: value === opt.value ? "#f0faff" : undefined,
                                            padding: "4px 6px",
                                            borderRadius: 4,
                                        }}
                                        onClick={() => handleStatusClick(opt.value)}
                                    >
                                        <span style={{ flex: 1, fontWeight: 500, color: opt.color }}>{opt.label}</span>

                                        {showTimeInputs && (
                                            <>
                                                <input
                                                    type="time"
                                                    value={timeForOpt.inTime || ""}
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{ width: 85 }}
                                                    onChange={(e) =>
                                                        setTimeState((prev) => ({
                                                            ...prev,
                                                            [cellKey]: {
                                                                ...prev[cellKey],
                                                                [opt.value]: {
                                                                    ...prev[cellKey]?.[opt.value],
                                                                    inTime: e.target.value,
                                                                },
                                                            },
                                                        }))
                                                    }
                                                />
                                                <input
                                                    type="time"
                                                    value={timeForOpt.outTime || ""}
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{ width: 85 }}
                                                    onChange={(e) =>
                                                        setTimeState((prev) => ({
                                                            ...prev,
                                                            [cellKey]: {
                                                                ...prev[cellKey],
                                                                [opt.value]: {
                                                                    ...prev[cellKey]?.[opt.value],
                                                                    outTime: e.target.value,
                                                                },
                                                            },
                                                        }))
                                                    }
                                                />
                                            </>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </Card>
                );

                return (
                    <Popover content={content} trigger="click" open={open} onOpenChange={setOpen} placement="bottom">
                        <div
                            style={{
                                border: "1px solid #d9d9d9",
                                borderRadius: 4,
                                padding: "2px 6px",
                                cursor: "pointer",
                                background: "#fff",
                                fontSize: 12,
                            }}
                        >
                            {value || "-"}
                        </div>
                    </Popover>
                );
            }
        );

        useEffect(() => {
            if (!selectedMonth) return;
            const totalDays = dayjs(selectedMonth).daysInMonth();
            const newDays: Day[] = Array.from({ length: totalDays }, (_, i) => {
                const date = dayjs(`${selectedMonth}-${i + 1}`).format("YYYY-MM-DD");
                const dayLabel = dayjs(date).format("ddd");
                return {
                    label: i + 1,
                    date,
                    dayName: dayLabel,
                };
            });
            setDaysInMonth(newDays);
        }, [selectedMonth]);

        const formattedData = useMemo(() => {
            return (attendancelist || []).map((emp: any) => {
                const attendanceMap: Record<string, string> = {};
                if (emp.attendance_status) {
                    emp.attendance_status.split(",").forEach((entry: string) => {
                        const [date, type] = entry.trim().split(":").map((s) => s.trim());
                        if (date && type) {
                            attendanceMap[date] = type;
                        }
                    });
                }

                const leaveFroms = emp.leave_from_dates ? emp.leave_from_dates.split(",").map((d: any) => d.trim()) : [];
                const leaveTos = emp.leave_to_dates ? emp.leave_to_dates.split(",").map((d: any) => d.trim()) : [];

                const leaveDates: string[] = [];
                for (let i = 0; i < leaveFroms.length; i++) {
                    const from = dayjs(leaveFroms[i]);
                    const to = dayjs(leaveTos[i]);
                    const diff = to.diff(from, "day");

                    for (let j = 0; j <= diff; j++) {
                        leaveDates.push(from.add(j, "day").format("YYYY-MM-DD"));
                    }
                }

                return {
                    ...emp,
                    attendanceMap,
                    leave_dates: leaveDates,
                };
            });
        }, [attendancelist]);

        const filteredData = useMemo(() => {
            return formattedData.filter((emp) => {
                const deptMatch = selectedDept ? emp.department === selectedDept : true;
                const projMatch = selectedProject
                    ? emp.project?.split(",").map((p: string) => p.trim()).includes(selectedProject)
                    : true;
                const empMatch = selectedEmployee ? emp.employee_id === Number(selectedEmployee) : true;

                return deptMatch && projMatch && empMatch;
            });
        }, [formattedData, selectedDept, selectedProject, selectedEmployee]);

        // Apply pagination
        const paginatedData = useMemo(() => {
            const start = (currentPage - 1) * pageSize;
            const end = start + pageSize;
            return filteredData.slice(start, end);
        }, [filteredData, currentPage]);

        const filteredDays = useMemo(() => {
            return selectedDay ? daysInMonth.filter((d) => d.date === selectedDay) : daysInMonth;
        }, [daysInMonth, selectedDay]);

        useEffect(() => {
            const newState: { [key: string]: boolean } = {};
            filteredData.forEach((emp) => {
                daysInMonth.forEach((day) => {
                    const key = `${emp.employee_id}-${day.date}`;
                    newState[key] = (emp.punch_dates ?? []).includes(day.date);
                });
            });
            setCheckedState(newState);
            setOriginalCheckedState(newState);
        }, [filteredData, daysInMonth]);

        return (
            <div style={{ overflowX: "auto", paddingBottom: 20 }}>
                <div style={{ marginBottom: 16 }}>
                    <button
                        onClick={() => {
                            const changedData = Object.entries(attendanceState).map(([key, value]) => {
                                const cellTimesForStatus = timeState[key]?.[value] || {};
                                const [empId, date] = key.split(/-(.+)/);
                                return {
                                    employee_id: empId,
                                    date,
                                    status: value,
                                    inTime: cellTimesForStatus.inTime || "",
                                    outTime: cellTimesForStatus.outTime || "",
                                };
                            });

                            if (changedData.length > 0) {
                                dispatch(createBulkPunchIn(changedData)).then((res: any) => {
                                    if (res.meta.requestStatus === "fulfilled") {
                                        message.success(res.payload.message);
                                    } else {
                                        message.warning(res.payload.status);
                                    }
                                });
                            }
                        }}
                    >
                        Save
                    </button>
                </div>

                <table style={{ borderCollapse: "collapse", width: "100%", minWidth: "700px" }}>
                    <thead>
                        <tr>
                            <th
                                style={{
                                    position: "sticky",
                                    left: 0,
                                    zIndex: 2,
                                    background: "#f7f7f7",
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    minWidth: 150,
                                }}
                            >
                                Employee
                            </th>
                            {filteredDays.map((day) => (
                                <th
                                    key={`daynum-${day.date}`}
                                    style={{
                                        border: "1px solid #ccc",
                                        padding: "4px",
                                        textAlign: "center",
                                        background: "#f1f1f1",
                                        fontSize: 11,
                                        fontWeight: 600,
                                    }}
                                >
                                    {day.label}
                                </th>
                            ))}
                        </tr>

                        <tr>
                            <th
                                style={{
                                    position: "sticky",
                                    left: 0,
                                    zIndex: 2,
                                    background: "#f7f7f7",
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    minWidth: 150,
                                }}
                            >
                                Day
                            </th>
                            {filteredDays.map((day) => (
                                <th
                                    key={`dayname-${day.date}`}
                                    style={{
                                        border: "1px solid #ccc",
                                        padding: "4px",
                                        textAlign: "center",
                                        background: "#eef",
                                        fontSize: 10,
                                    }}
                                >
                                    {day.dayName}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {paginatedData.map((emp) => (
                            <tr key={emp.employee_id}>
                                <td
                                    style={{
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 1,
                                        background: "#fff",
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {emp.name}
                                </td>
                                {filteredDays.map((day: any) => (
                                    <td
                                        key={`${emp.employee_id}-${day.date}`}
                                        style={{
                                            border: "1px solid #ccc",
                                            padding: "2px",
                                            textAlign: "center",
                                            minWidth: 60,
                                        }}
                                    >
                                        <AttendanceCell
                                            empId={emp.employee_id}
                                            date={day.date}
                                            value={
                                                attendanceState[`${emp.employee_id}-${day.date}`] ??
                                                emp.attendanceMap?.[day.date]
                                            }
                                            onChange={(val) => {
                                                setAttendanceState((prev) => ({
                                                    ...prev,
                                                    [`${emp.employee_id}-${day.date}`]: val,
                                                }));
                                            }}
                                        />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>

                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={filteredData.length}
                    onChange={(page) => setCurrentPage(page)}
                    style={{ marginTop: 16, textAlign: "right" }}
                />
            </div>
        );
    };

    function firstRoot(data: Employee[]): Employee | null {
        if (!Array.isArray(data) || data.length === 0) return null;
        return data[0];
    }

    const EmployeeAttendanceTree: React.FC<{ data: Employee[] }> = ({ data }) => {
        const root = useMemo(() => firstRoot(data), [data]);
        const [path, setPath] = useState<Employee[]>(() => (root ? [root] : []));
        const current = path[path.length - 1];

        const drillDown = (emp: Employee) => setPath((prev) => [...prev, emp]);
        const nextLevel = (index: number) => setPath((prev) => prev.slice(0, index + 1));
        const goTop = () => root && setPath([root]);

        if (!root) return <div>No employee data available</div>;

        return (
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 14, padding: "8px 0 10px"}}>
                {path.map((emp, idx) => (
                    <React.Fragment key={emp.EmployeeID}>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <EmployeeNode
                                employee={emp}
                                onClick={() => (idx === path.length - 1 ? undefined : nextLevel(idx))}
                                showChevron={idx !== path.length - 1}
                            />
                        </div>
                        {idx < path.length - 1 && (
                            <div
                                style={{
                                    width: 2,
                                    height: 20,
                                    background: "#e5e7eb",
                                    borderRadius: 2,
                                }}
                            />
                        )}
                    </React.Fragment>
                ))}

                <div
                    style={{
                        width: "100%",
                        maxWidth: 1080,
                        border: "2px solid #5b5bf7",
                        background: "#ffffff",
                        borderRadius: 12,
                        padding: 16,
                        marginTop: 8,
                    }}
                >
                    {current.Subordinates?.length ? (
                        <div
                            style={{
                                display: "grid",
                                gridAutoFlow: "column",
                                gridAutoColumns: "min-content",
                                gap: 14,
                                overflowX: "auto",
                                padding: 2,
                            }}
                        >
                            {current.Subordinates.map((s) => (
                                <div key={s.EmployeeID} style={{ display: "inline-flex" }}>
                                    <EmployeeNode employee={s} onClick={drillDown} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div
                            style={{
                                color: "#6b7280",
                                fontSize: 13,
                                padding: 12,
                                border: "1px dashed #e5e7eb",
                                borderRadius: 8,
                                background: "#fafafa",
                                textAlign: "center",
                                cursor:"pointer"
                            }}
                            onClick={goTop}
                        >
                            No direct subordinates. (Click to go back to top)
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // Handle file selection
    const handleImportFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            handleCSVImport(file);
            e.target.value = "";
        }
    };

    const handleDateChange = (value: any) => {
        if (value) {
            const formattedDate = dayjs(value).format("YYYY-MM-DD");
            setSelectedDate(formattedDate);
        }
    };
    const disableFutureDates = (current: dayjs.Dayjs) => {
        return current && current > dayjs().endOf("day");
    };

    useEffect(() => {
        dispatch(getEmployeeAttendanceByDate(selectedDate));
        dispatch(fetchAllattendanceReport()).then((res) => {
            setattendacnelist(res.payload.data);
        });
        dispatch(fetchAllProjects());
        dispatch(fetchAllDepartments());
        dispatch(getEmployeeAttendancehierarchy(selectedDate))
            .then((res) => {
                setemployeeAttendancehir(res.payload.data)
            })
    }, [dispatch, selectedDate]);

    const getModalContainer = () =>
        document.getElementById("modal-datepicker") || document.body;


    const downloadSampleFormat = [
        {
            EmployeeId: 137,
            PunchDate: "2025-07-26",      // Correct format: YYYY-MM-DD
            PunchTime: "09:00",           // HH:mm format
            PunchOut: "17:30",            // HH:mm format
            PunchType: "IN",              // Can be 'IN' or 'OUT' (optional in your model)
            EmployeeCode: "EMP003",       // Alphanumeric employee code
            Longitude: 77.4727196,
            Latitude: 28.448938,
            CreatedBy: 124
        }
    ];
    const { Option } = Select;

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedDay, setSelectedDay] = useState<string | undefined>();
    const [attendancelist, setattendacnelist] = useState<any>(null);
    const { projectsData } = useSelector((state: any) => state.project.projects);

    const monthsOfYear = Array.from({ length: 12 }, (_, i) => {
        const month = dayjs().month(i).format("MM");
        const label = dayjs().month(i).format("MMMM");
        return {
            label,
            value: `${dayjs().year()}-${month}`,
        };
    });

    const statusChoose = [
        { value: "Select", label: "Select" },
        { value: "Present", label: "Present" },
        { value: "Absent", label: "Absent" },
    ];

    const getModalContainer2 = () => {
        const modalElement = document.getElementById("modal_datepicker");
        return modalElement ? modalElement : document.body;
    };

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Attendance Manager</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Attendance</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Attendance Manager
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div
                                className="position-relative d-inline-block "
                                style={{ width: 160 }}
                            >
                                <i
                                    className="ti ti-file-analytics text-white position-absolute"
                                    style={{
                                        left: 5,
                                        top: "40%",
                                        transform: "translateY(-50%)",
                                        zIndex: 1,
                                    }}
                                />
                                <DatePicker
                                    className="form-control border-0 ps-4 bg-primary text-white shadow-none"
                                    format={{
                                        format: "DD-MM-YYYY",
                                        type: "mask",
                                    }}
                                    getPopupContainer={getModalContainer}
                                    placeholder="DD-MM-YYYY"
                                    onChange={handleDateChange}
                                    disabledDate={disableFutureDates}
                                    value={dayjs(selectedDate)}
                                    style={{ width: "100%" }}
                                />
                            </div>

                            <div className="ms-2 head-icons">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* <div className="row">
                        <AttendanceSummaryCard
                            title="Total Employees"
                            value={employeeAttendanceAnalytics?.analytics.totalEmployees}
                            iconClass="ti ti-users fs-18 text-primary"
                            bgClass="bg-primary-transparent border border-primary"
                        />
                        <AttendanceSummaryCard
                            title="Present Employees"
                            value={employeeAttendanceAnalytics?.analytics.totalPresent}
                            iconClass="ti ti-circle-check fs-18 text-success"
                            bgClass="bg-success-transparent border border-success"
                        />
                        <AttendanceSummaryCard
                            title="Absent Employees"
                            value={employeeAttendanceAnalytics?.analytics.totalAbsent}
                            iconClass="ti ti-circle-x fs-18 text-danger"
                            bgClass="bg-danger-transparent border border-danger"
                        />
                        <AttendanceSummaryCard
                            title="Work From Home"
                            value={employeeAttendanceAnalytics?.analytics.totalWorkFromHome}
                            iconClass="ti ti-home fs-18 text-info"
                            bgClass="bg-info-transparent border border-info"
                        />
                    </div> */}

                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>📊 Employee Today's Attendance</h5>
                        </div>
                        <div className="card-body p-0">
                            <div ref={orgViewportRef} className="org-viewport container mt-4">
                                <div className="org-canvas">
                                    <EmployeeAttendanceTree data={filteredHierarchy} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            {/* /Page Wrapper */}
            {/* Edit Attendance */}
            <div className="modal fade" id="edit_attendance">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Attendance</h4>
                            <button
                                type="button"
                                className="btn-close custom-btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <form>
                            <div className="modal-body pb-0">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <label className="form-label">Date</label>
                                            <div className="input-icon input-icon-new position-relative w-100 me-2">
                                                <DatePicker
                                                    className="form-control datetimepicker"
                                                    format={{
                                                        format: "DD-MM-YYYY",
                                                        type: "mask",
                                                    }}
                                                    getPopupContainer={getModalContainer}
                                                    placeholder="DD-MM-YYYY"
                                                />
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-calendar" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Check In</label>
                                            <div className="input-icon input-icon-new position-relative w-100">
                                                <TimePicker
                                                    getPopupContainer={getModalContainer2}
                                                    use12Hours
                                                    placeholder="Choose"
                                                    format="h:mm A"
                                                    className="form-control timepicker"
                                                />
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-clock-hour-3" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Check Out</label>
                                            <div className="input-icon input-icon-new position-relative w-100">
                                                <TimePicker
                                                    getPopupContainer={getModalContainer2}
                                                    use12Hours
                                                    placeholder="Choose"
                                                    format="h:mm A"
                                                    className="form-control timepicker"
                                                />
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-clock-hour-3" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Break</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="30 Min	"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Late</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="32 Min"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <label className="form-label">Production Hours</label>
                                            <div className="input-icon input-icon-new position-relative w-100">
                                                <TimePicker
                                                    getPopupContainer={getModalContainer2}
                                                    use12Hours
                                                    placeholder="Choose"
                                                    format="h:mm A"
                                                    className="form-control timepicker"
                                                />
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-clock-hour-3" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="mb-3 ">
                                            <label className="form-label">Status</label>
                                            <CommonSelect
                                                className="select"
                                                options={statusChoose}
                                                defaultValue={statusChoose[1]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-light me-2"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    data-bs-dismiss="modal"
                                    className="btn btn-primary"
                                >
                                    Save Changes
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* /Edit Attendance */}
            {/* Attendance Report */}
            <div className="modal fade" id="attendance_report">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Attendance</h4>
                            <button
                                type="button"
                                className="btn-close custom-btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <i className="ti ti-x" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="card shadow-none bg-transparent-light">
                                <div className="card-body pb-1">
                                    <div className="row align-items-center">
                                        <div className="col-lg-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <span className="avatar avatar-sm avatar-rounded flex-shrink-0 me-2">
                                                    <ImageWithBasePath
                                                        src="assets/img/profiles/avatar-02.jpg"
                                                        alt="Img"
                                                    />
                                                </span>
                                                <div>
                                                    <h6 className="fw-medium">Anthony Lewis</h6>
                                                    <span>UI/UX Team</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="mb-3 text-sm-end">
                                                        <span>Date</span>
                                                        <p className="text-gray-9 fw-medium">15 Apr 2025</p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="mb-3 text-sm-end">
                                                        <span>Punch in at</span>
                                                        <p className="text-gray-9 fw-medium">09:00 AM</p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="mb-3 text-sm-end">
                                                        <span>Punch out at</span>
                                                        <p className="text-gray-9 fw-medium">06:45 PM</p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="mb-3 text-sm-end">
                                                        <span>Status</span>
                                                        <p className="text-gray-9 fw-medium">Present</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card shadow-none border mb-0">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-3">
                                            <div className="mb-4">
                                                <p className="d-flex align-items-center mb-1">
                                                    <i className="ti ti-point-filled text-dark-transparent me-1" />
                                                    Total Working hours
                                                </p>
                                                <h3>12h 36m</h3>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="mb-4">
                                                <p className="d-flex align-items-center mb-1">
                                                    <i className="ti ti-point-filled text-success me-1" />
                                                    Productive Hours
                                                </p>
                                                <h3>08h 36m</h3>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="mb-4">
                                                <p className="d-flex align-items-center mb-1">
                                                    <i className="ti ti-point-filled text-warning me-1" />
                                                    Break hours
                                                </p>
                                                <h3>22m 15s</h3>
                                            </div>
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="mb-4">
                                                <p className="d-flex align-items-center mb-1">
                                                    <i className="ti ti-point-filled text-info me-1" />
                                                    Overtime
                                                </p>
                                                <h3>02h 15m</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-8 mx-auto">
                                            <div
                                                className="progress bg-transparent-dark mb-3"
                                                style={{ height: 24 }}
                                            >
                                                <div
                                                    className="progress-bar bg-success rounded me-2"
                                                    role="progressbar"
                                                    style={{ width: "18%" }}
                                                />
                                                <div
                                                    className="progress-bar bg-warning rounded me-2"
                                                    role="progressbar"
                                                    style={{ width: "5%" }}
                                                />
                                                <div
                                                    className="progress-bar bg-success rounded me-2"
                                                    role="progressbar"
                                                    style={{ width: "28%" }}
                                                />
                                                <div
                                                    className="progress-bar bg-warning rounded me-2"
                                                    role="progressbar"
                                                    style={{ width: "17%" }}
                                                />
                                                <div
                                                    className="progress-bar bg-success rounded me-2"
                                                    role="progressbar"
                                                    style={{ width: "22%" }}
                                                />
                                                <div
                                                    className="progress-bar bg-warning rounded me-2"
                                                    role="progressbar"
                                                    style={{ width: "5%" }}
                                                />
                                                <div
                                                    className="progress-bar bg-info rounded me-2"
                                                    role="progressbar"
                                                    style={{ width: "3%" }}
                                                />
                                                <div
                                                    className="progress-bar bg-info rounded"
                                                    role="progressbar"
                                                    style={{ width: "2%" }}
                                                />
                                            </div>
                                        </div>
                                        <div className="co-md-12">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <span className="fs-10">06:00</span>
                                                <span className="fs-10">07:00</span>
                                                <span className="fs-10">08:00</span>
                                                <span className="fs-10">09:00</span>
                                                <span className="fs-10">10:00</span>
                                                <span className="fs-10">11:00</span>
                                                <span className="fs-10">12:00</span>
                                                <span className="fs-10">01:00</span>
                                                <span className="fs-10">02:00</span>
                                                <span className="fs-10">03:00</span>
                                                <span className="fs-10">04:00</span>
                                                <span className="fs-10">05:00</span>
                                                <span className="fs-10">06:00</span>
                                                <span className="fs-10">07:00</span>
                                                <span className="fs-10">08:00</span>
                                                <span className="fs-10">09:00</span>
                                                <span className="fs-10">10:00</span>
                                                <span className="fs-10">11:00</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Attendance Report */}

            <Modal
                open={showSampleModal}
                onCancel={() => setShowSampleModal(false)}
                footer={null}
                centered
                width={700}
            >
                <div className="position-relative">
                    <div
                        className="position-absolute"
                        style={{ top: -4, right: 27, zIndex: 2 }}
                    >
                        <button
                            className="btn btn-sm btn-primary"
                            onClick={() => exportToCSV(downloadSampleFormat, "attendance_sample")}
                        >
                            <i className="ti ti-download me-1" />
                            <span className="d-none d-sm-inline">Download Sample CSV</span>
                        </button>
                    </div>
                    <div
                        style={{
                            overflowX: "auto",
                            maxHeight: "60vh",
                            paddingTop: "2rem",
                            paddingBottom: "1rem",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                        }}
                    >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>EmployeeId</th>
                                    <th>PunchDate</th>
                                    <th>PunchTime</th>
                                    <th>PunchOut</th>
                                    <th>PunchType</th>
                                    <th>EmployeeCode</th>
                                    <th>Longitude</th>
                                    <th>Latitude</th>
                                    <th>CreatedBy</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>137</td>
                                    <td>2025-07-22</td>
                                    <td>09:00</td>
                                    <td>17:30</td>
                                    <td>IN</td>
                                    <td>EMP003</td>
                                    <td>77.4727196</td>
                                    <td>28.448938</td>
                                    <td>124</td>
                                </tr>
                                <tr>
                                    <td>138</td>
                                    <td>2025-07-22</td>
                                    <td>10:15</td>
                                    <td>18:45</td>
                                    <td>IN</td>
                                    <td>EMP004</td>
                                    <td>77.498325</td>
                                    <td>28.501112</td>
                                    <td>124</td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                </div>
            </Modal>

            <Drawer
                title="Attendance"
                width={1050}
                onClose={() => setIsDrawerOpen(false)}
                open={isDrawerOpen}
                extra={
                    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                        {/* Legend Items */}
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                <span
                                    style={{
                                        width: 16,
                                        height: 16,
                                        backgroundColor: "#66ccff", // Present
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        display: "inline-block",
                                    }}
                                />
                                <span>Present</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                <span
                                    style={{
                                        width: 16,
                                        height: 16,
                                        backgroundColor: "#d3d3d3", // Weekly Off
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        display: "inline-block",
                                    }}
                                />
                                <span>Weekly Off</span>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                <span
                                    style={{
                                        width: 16,
                                        height: 16,
                                        backgroundColor: "#ffd966", // Leave
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        display: "inline-block",
                                    }}
                                />
                                <span>Leave</span>
                            </div>
                        </div>
                    </div>
                }
            >
                {/* Month Picker */}
                <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
                    <Col>
                        <Select
                            placeholder="Department"
                            allowClear
                            value={selectedDept}
                            onChange={setSelectedDept}
                            style={{ width: 150 }}
                        >
                            {departments.map((dept: any) => (
                                <Option key={dept.Id} value={dept.Name}>
                                    {dept.Name}
                                </Option>
                            ))}
                        </Select>
                    </Col>

                    <Col>
                        <Select
                            placeholder="Project"
                            allowClear
                            value={selectedProject}
                            onChange={setSelectedProject}
                            style={{ width: 150 }}
                        >
                            {projectsData.map((proj: any) => (
                                <Option key={proj.project_id} value={proj.project_name}>
                                    {proj.project_name}
                                </Option>
                            ))}
                        </Select>
                    </Col>

                    <Col>
                        <Select
                            placeholder="Employee"
                            allowClear
                            value={selectedEmployee ?? undefined}
                            onChange={setSelectedEmployee}
                            style={{ width: 160 }}
                        >
                            {attendancelist?.map((emp: any) => (
                                <Select.Option
                                    key={emp.employee_id}
                                    value={String(emp.employee_id)}
                                >
                                    {emp.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col>
                        <Select
                            placeholder="Month"
                            value={selectedMonth}
                            onChange={setSelectedMonth}
                            style={{ width: 120 }}
                        >
                            {monthsOfYear.map((month) => (
                                <Option key={month.value} value={month.value}>
                                    {month.label}
                                </Option>
                            ))}
                        </Select>
                    </Col>

                    <Col>
                        <Select
                            placeholder="Day"
                            allowClear
                            value={selectedDay}
                            onChange={setSelectedDay}
                            style={{ width: 120 }}
                            disabled={!selectedMonth}
                        >
                            {Array.from(
                                { length: dayjs(selectedMonth).daysInMonth() },
                                (_, i) => {
                                    const date = dayjs(`${selectedMonth}-${i + 1}`).format("YYYY-MM-DD");
                                    const label = `${i + 1} (${dayjs(date).format("ddd")})`;
                                    return (
                                        <Option key={date} value={date}>
                                            {label}
                                        </Option>
                                    );
                                }
                            )}
                        </Select>
                    </Col>

                    {/* <Col>
                        <Button type="primary" onClick={handleBuildAttendance}>
                            Build Attendance
                        </Button>
                    </Col> */}
                </Row>


                {/* Main Attendance Grid */}
                <CustomAttendanceTable
                    attendancelist={attendancelist}
                    selectedMonth={selectedMonth}
                    selectedDept={selectedDept}
                    selectedProject={selectedProject}
                    selectedDay={selectedDay}
                    selectedEmployee={selectedEmployee}
                />
            </Drawer>
        </>
    );
};

export default AttendanceManager;
